import { CONCILIATION_FR_FR } from "#pages/backoffice/conciliation/translations/conciliation-fr-fr";
import customerAndSupplier from "./customer-and-supplier.json";
import eventConference from "./event-conference.json";
import accountsPayableReceivable from "./accounts-payable-receivable.json";
import bills from "./bills.json";
import finExManagerialReport from "./finex-managerial-report.json";
import planOfAccounts from "./plan-of-accounts.json";
import stockTransferHistory from "./stock-transfer-history.json";

export const backofficeFr = {
	conciliation: CONCILIATION_FR_FR,
	customerAndSupplier,
	eventConference,
	accountsPayableReceivable,
	bills,
	finExManagerialReport,
	planOfAccounts,
	stockTransferHistory,
};
